/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobThread {
    getFixupPrototypeFunction() { return BackgroundJobThread.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobThread>): BackgroundJobThread {
        let obj = Object.assign(new BackgroundJobThread(), model);
        BackgroundJobThread.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobThread>): BackgroundJobThread {
        if (!model) return null;
        return BackgroundJobThread.newInstance(<BackgroundJobThread> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobThread) {
        if (!obj) return;

        models.BackgroundJobThread.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobThread): boolean {
        Object.setPrototypeOf(obj, BackgroundJobThread.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.process_id === undefined) {
            this.process_id = 0;
        }
        if (this.thread_id === undefined) {
            this.thread_id = 0;
        }
        if (this.frames) {
            for (let val of this.frames) {
                models.BackgroundJobThreadFrame.fixupPrototype(val);
            }
        }
    }

    /**
     * Executor of the Background Job
     */
    executor: models.BackgroundJobExecutor;

    /**
     * ID of the process
     */
    process_id: number;

    /**
     * Name of the process
     */
    process_name: string;

    /**
     * ID of the thread
     */
    thread_id: number;

    /**
     * Name of the thread
     */
    thread_name: string;

    /**
     * Stack frames for the thread
     */
    frames: Array<models.BackgroundJobThreadFrame>;

}
